import { ChangeDetectionStrategy, Component, Injector, Input } from '@angular/core';

import { AdminsAvatarsComponent, DialogService, DialogWidth } from '@recruitee/user-interface';

import type { Account } from '../../../client/integrations-client.types';
import type { DynamicAdminsInputConfig } from '../../types';
import { DynamicFormInput } from '../dynamic-form/dynamic-form-input/dynamic-form-input';

export class AdminsInput extends DynamicFormInput<DynamicAdminsInputConfig> {}

@Component({
  selector: 'rti-admins-input',
  templateUrl: './admins-input.component.html',
  styleUrls: ['./admins-input.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AdminsAvatarsComponent],
})
export class AdminsInputComponent {
  @Input() public input: AdminsInput;

  constructor(
    private injector: Injector,
    private dialogService: DialogService,
  ) {}

  public get admins(): Array<Account['admin']> {
    return this.input.control.value;
  }

  public async editAdmins() {
    const { AdminsSelectDialogComponent } = await import(
      '../../../misc/admins-select-dialog/admins-select-dialog.component'
    );
    const data = {
      assignments: this.adminIds,
      preventAdminRemove: this.input.config.preventCurrentAdminRemove,
      minSelectedAdmins: this.input.config.required ? 1 : 0,
      maxSelectedAdmins: this.input.config.maxSelectedAdmins,
    };
    const config = { width: DialogWidth.SmallX, injector: this.injector };
    this.dialogService
      .openCustom(AdminsSelectDialogComponent, config, data)
      .afterClosed.subscribe(admins => {
        if (admins) {
          this.input.control.setValue(admins);
        }
      });
  }

  private get adminIds(): number[] {
    return this.admins.map(a => a.id);
  }
}
